import React from 'react';
import './ContactUs.css';
import Typewriter from './Typewriter';
import NeuralNetworkBackground from './NeuralNetworkBackground'; // Import background

const ContactUs = React.forwardRef(({ inView }, ref) => {
  return (
    <section id="contact" ref={ref} className="contact-section"> {/* Add ref */}
      <NeuralNetworkBackground className="neural-network-background" /> {/* Render background with custom neuron count */}
      <div className="content-wrapper" style={{ position: 'relative', zIndex: 1 }}> {/* Wrap content */}
        <div className="container">
          <h2 className="contact-title">CONTACT</h2>
          <div className="contact-details">
            <p className="contact-company-name">
              <Typewriter id="contactus-l1-part1" speed={100} replay={inView}>Jyeshta </Typewriter>
              <span className="contact-ai">
                <Typewriter id="contactus-l1-ai" speed={100} replay={inView} showCursor={true} cursorClass="contact-cursor">AI</Typewriter>
              </span>
              <Typewriter id="contactus-l1-part2" speed={100} replay={inView}> Labs Pvt Ltd</Typewriter>
            </p> {/* Pass replay */}
            <p>GA, Ground Floor, Peace Homes "108/30"</p>
            <p>Manukula Vinayagar Street, Thiruvannamalai-606603</p>
            <a href="mailto:info@jyeshta.xyz" className="contact-email">info@jyeshta.xyz</a>
          </div>
        </div>
      </div>
    </section>
  );
}); // Use React.forwardRef

export default ContactUs;